import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';

import PrivateRoute from 'yeself-client-common/security/components/PrivateRoute';

import Topbar from 'Console/components/Topbar';
import MobileDrawer from 'Console/components/MobileDrawer';
import Applications from 'Console/components/applications/Applications';
import ApplicationDetail from 'Console/components/applications/detail/Detail';
import Accounts from 'Console/components/accounts/Accounts';
import AccountDetail from 'Console/components/accounts/detail/Detail';
import NoMatchRoute from 'Console/components/NoMatchRoute';
import Audit from 'Console/components/audit/Audit';
import AccountNotifications from 'Console/components/accountNotifications/AccountNotifications';
import { ConnetedAnalyticsReportEmbed } from 'Console/components/analytics/AnalyticsReportEmbed';

import { handleDrawerToggle } from 'Console/data/app/actions';
import { ROUTES } from 'Console/constants/routes';

const Application = ({ mobileMenuOpened, handleDrawerToggle }) => (
    <Grid container>
        <Switch>
            <>
                <div style={{ flex: 1 }}>
                    <Topbar handleDrawerToggle={handleDrawerToggle} />
                    <MobileDrawer
                        handleDrawerToggle={handleDrawerToggle}
                        mobileMenuOpened={mobileMenuOpened}
                    />
                    <main style={{ flexGrow: 1, paddingTop: 48 }}>
                        <Switch>
                            <PrivateRoute exact path={ROUTES.BASE} component={Applications} />
                            <PrivateRoute path={ROUTES.APPLICATIONS} component={Applications} />
                            <PrivateRoute
                                path={ROUTES.APPLICATION_DETAIL}
                                component={ApplicationDetail}
                            />
                            <PrivateRoute path={ROUTES.AUDIT_GLOBAL} component={Audit} />
                            <PrivateRoute path={ROUTES.ACCOUNTS} component={Accounts} />

                            <PrivateRoute
                                path={ROUTES.NOTIFICATIONS}
                                exact
                                component={AccountNotifications}
                            />
                            <PrivateRoute path={ROUTES.ACCOUNT_DETAIL} component={AccountDetail} />
                            <PrivateRoute path={ROUTES.ANALYTICS} component={ConnetedAnalyticsReportEmbed} />
                            {/* <PrivateRoute
                                <PrivateRoute path={ROUTES.ACCOUNT_DETAIL} component={AccountDetail} />
                            }
                            {/* <PrivateRoute
                                    exact
                                    path="/applications/:applicationId"
                                    component={ApplicationDetailScreenContainer}
                                /> */}
                            {/* <PrivateRoute
                                    exact
                                    path={ROUTES.APPLICATIONS}
                                    component={ApplicationListScreenContainer}
                                /> */}
                        </Switch>
                    </main>
                </div>
            </>
            <Route component={NoMatchRoute} />
        </Switch>
    </Grid>
);

export default connect(
    (state) => ({
        mobileMenuOpened: state.app.mobileMenuOpened,
    }),
    {
        handleDrawerToggle,
    }
)(Application);
